import React, { useRef } from 'react';
import { MdLocationPin } from 'react-icons/md';
import { ImPhone } from 'react-icons/im';
import { TfiEmail } from 'react-icons/tfi';
import contact from '../../assets/videos/palakxdev-contact.mp4';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                'service_3fu9vg9',
                'template_50hnqar',
                form.current,
                'IVkfn2AJoU90031vD'
            )
            .then(
                (result) => {
                    console.log(result.text);
                    Swal.fire({
                        icon: 'success',
                        title: 'Your message has been send',
                    });
                },
                (error) => {
                    console.log(error.text);
                }
            );
        e.target.reset();
    };

    return (
        <section className="mb-16">
            <div className="mt-16 px-4 lg:px-60 md:px-32">
                <div>
                    <h2 className="text-4xl text-center text-accent font-bold">
                        Get in Touch
                    </h2>
                    <div className="flex items-center mt-2 mb-4">
                        <span className="h-0.5 bg-accent w-24"></span>
                        <p className="ml-3">Contact with me</p>
                    </div>
                    {/* ==================location, number and mail================== */}
                    <div className="flex flex-wrap justify-center mx-auto">
                        <div
                            data-aos="fade-up"
                            data-aos-duration="2000"
                            className="p-6 lg:p-16 flex flex-col items-center"
                        >
                            <span>
                                <MdLocationPin
                                    className="text-accent mb-2"
                                    size={40}
                                ></MdLocationPin>
                            </span>
                            <span>Dhaka, Bangladesh</span>
                        </div>
                        <div
                            data-aos="fade-up"
                            data-aos-duration="2000"
                            className="p-6 lg:p-16 flex flex-col items-center"
                        >
                            <span>
                                <ImPhone
                                    className="text-accent mb-2"
                                    size={40}
                                ></ImPhone>
                            </span>
                            <span>+880 1795-225530</span>
                        </div>
                        <div
                            data-aos="fade-up"
                            data-aos-duration="2000"
                            className="p-6 lg:p-16 flex flex-col items-center"
                        >
                            <span>
                                <TfiEmail
                                    className="text-accent mb-2"
                                    size={40}
                                ></TfiEmail>
                            </span>
                            <span>palakxdev@gmail.com</span>
                        </div>
                    </div>
                </div>
                {/* ==================contact from==================  */}
                <div className="p-2 lg:p-0">
                    <div className="flex items-center flex-wrap bg-secondary rounded-md p-4 lg:p-8">
                        <video
                            data-aos="fade-up"
                            data-aos-duration="2500"
                            className="rounded-2xl w-full lg:w-2/4"
                            autoPlay
                            muted
                            loop
                            // width={660}
                            src={contact}
                        ></video>
                        <form
                            data-aos="fade-up"
                            data-aos-duration="2500"
                            ref={form}
                            onSubmit={sendEmail}
                            className="w-full lg:w-2/4 mt-4 lg:mt-0"
                        >
                            <div className="flex flex-col items-center">
                                <input
                                    type="text"
                                    name="to_name"
                                    placeholder="Your Name"
                                    className="input input-md w-full rounded-sm max-w-xs text-black mb-2"
                                />
                                <input
                                    type="email"
                                    name="from_name"
                                    placeholder="Your Email"
                                    required
                                    className="input input-md w-full rounded-sm max-w-xs text-black mb-2"
                                />
                                <input
                                    type="number"
                                    name="number"
                                    placeholder="Your Phone"
                                    className="input input-md w-full rounded-sm max-w-xs text-black mb-2"
                                />
                                <textarea
                                    name="message"
                                    required
                                    className="textarea w-full text-black rounded-sm max-w-xs mb-2"
                                    placeholder="Your Message"
                                ></textarea>
                                <input
                                    type="submit"
                                    placeholder="Send now"
                                    className="input bg-accent text-white rounded-sm cursor-pointer w-32 mx-auto"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
